import React, {useState} from "react";
import {observer} from "mobx-react";
import {useStores} from "../../../Hooks";
import GeneralDialog from "../GeneralDialog";
import {
    FormControlLabel,
    Radio,
    RadioGroup,
} from "@mui/material";
import {uploadStatusEnum} from "../../../serverClientShared/sharedEnums";
import AppRedirectModal from "./AppRedirectModal";

const SelectDigitalTwinUploadModal = observer(() => {
    const [isAppRedirectModalOpen, setIsAppRedirectModalOpen] = useState(false);
    const {modalStore, generalStore} = useStores();

    const {name, uploadingMethod} = modalStore.modalData;

    const renderBody = () => {
        return (
            <RadioGroup
                value={uploadingMethod}
                onChange={e => modalStore.modalData.uploadingMethod = e.target.value}
                className='select-upload-method-radio-container'
            >
                <FormControlLabel
                    value={uploadStatusEnum.REGULAR}
                    control={<Radio color='primary'/>}
                    label={`${generalStore.translate('optimizedDigitalTwinModel')} (.frontline)`}
                />
                <FormControlLabel
                    value={uploadStatusEnum.AWAITING_UPLOAD}
                    control={<Radio color='primary'/>}
                    label={`3D CAD ${generalStore.translate('file')} (.step / .stp / .fbx / .obj)`}
                />
            </RadioGroup>
        )
    }

    const onConfirm = async () => {
        if (uploadingMethod === uploadStatusEnum.AWAITING_UPLOAD) {
            setIsAppRedirectModalOpen(true)
            return;
        }
        generalStore.isLoaderOpen = true;
        const {doMainAction} = modalStore.modalData;
        const onError = () => {
            generalStore.isLoaderOpen = false;
        }

        try {
            const success = await doMainAction(name, uploadingMethod);
            if (success) {
                generalStore.isLoaderOpen = false;
                modalStore.modalData.name = '';
                modalStore.modalData.uploadingMethod = '';
                modalStore.isSelectDigitalTwinUploadModalOpen = false;
            } else {
                onError();
            }
        } catch (e) {
            console.error(e);
            onError();
        }
    }

    return (
        <>
            <GeneralDialog
                openControl='isSelectDigitalTwinUploadModalOpen'
                className={'procedure-option-dialog site-prep-options'}
                title={generalStore.translate('selectUploadingMethod')}
                body={renderBody()}
                noCancel
                isConfirmDisabled={!uploadingMethod}
                confirmText={generalStore.translate('next')}
                onConfirm={onConfirm}
                extraClose
                goBackControl={'isCreateRenameModalOpen'}
            />
            <AppRedirectModal isAppRedirectModalOpen={isAppRedirectModalOpen} setIsAppRedirectModalOpen={setIsAppRedirectModalOpen}/>
        </>
    );
});

export default SelectDigitalTwinUploadModal;
